import React from "react";
import aboutImg from "../img/adt.jpg"; // ✅ Correct relative path
import "../css/about.css";
const About = () => {
  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5 align-items-center">

          {/* Image Section */}
          <div className="col-lg-6">
            <div
              className="about-img"
              style={{
                height: "400px",
                overflow: "hidden",
                borderRadius: "10px",
              }}
            >
              <img
                src={aboutImg}
                alt="About"
                className="img-fluid w-100 h-100"
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>

          {/* Text Section */}
          <div className="col-lg-6">
            <h6 className="section-title bg-white text-start text-primary pe-3">
              About Us
            </h6>
            <h1 className="mb-4">Welcome to Auxilium ITI</h1>
            <p className="mb-4">
            Founded in 1973, Auxilium Technical Training Centre began as a non-formal institute under the guidance of Rev. Fr. Joseph Amaladoss. Over the years, it gained official recognition, with the Welding trade affiliated to the State Government in 1975, followed by Wireman and Electrician trades under NCVT.
            </p>
            <p className="mb-4">
         Our mission is to equip students with practical skills and modern technical knowledge, bridging the gap between education and industry needs. We are committed to nurturing skilled, confident, and responsible professionals who can contribute to the nation’s industrial growth.
            </p>
   <p className="mb-4">
   <p className="mb-4">
We aspire to be a centre of excellence in vocational training, offering industry-aligned, skill-based education that promotes innovation, personal growth, and employability.            </p>
            </p>

            <div className="row gy-2 gx-4 mb-4">
              {[
                "Government Recognized ",
                "NCVT",
                "Quality Training",
                "Experienced Faculty ",
                "Well-Equipped Infrastructure ",
                "Career-Oriented Approach ",
              ].map((item, index) => (
                <div className="col-sm-6" key={index}>
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2"></i>
                    {item}
                  </p>
                </div>
              ))}
            </div>

       
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
